import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=558fb6c1&scoped=true&"
import script from "./VendorSelect.vue?vue&type=script&lang=js&"
export * from "./VendorSelect.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelect.vue?vue&type=style&index=0&id=558fb6c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558fb6c1",
  null
  
)

export default component.exports